import { object } from "prop-types";
import React from "react";

import styled from "styled-components/macro";
import { backgroundColor, borderRadius, negitiveMargin, padding } from "theme";

import TierPriceViewer from "Payments/TierPricing/TierPriceViewer/TierPriceViewer";
import { COST_TYPES } from "Signups/SharedComponents/costTypes";
import { useSignups } from "Signups/state";
import { useIsSuggestedDonation } from "Signups/stateHooks";

const Wrapper = styled("div")`
  max-width: fit-content;
  overflow: hidden; /* hides extra padding from accorion on hover */
  ${backgroundColor}
  ${borderRadius}
  ${padding}
  ${negitiveMargin}
`;

const CostInfoBadge = ({ signupItem }) => {
  const [state] = useSignups();
  const { currentSignupList: { signupListVerbs: { entity } = {} } = {} } =
    state;
  const isVolunterSignupType = state?.currentSignupList?.signupListTypeID === 7;
  const isSuggestedDonation = useIsSuggestedDonation();
  const tierData = signupItem?.fundIt?.cost?.amounts;
  const shouldDisplay =
    !isVolunterSignupType &&
    signupItem?.fundIt?.hasSignupCost &&
    signupItem?.fundIt?.cost?.costType &&
    signupItem?.fundIt?.cost?.costType !== COST_TYPES.PER_SIGNUP;

  const isPerHousehold =
    signupItem?.fundIt?.cost?.costType === COST_TYPES.PER_ITEM &&
    tierData.length === 1;

  if (!shouldDisplay) return null;

  return (
    <Wrapper $variant="badge">
      <TierPriceViewer
        tierData={tierData}
        entity={isPerHousehold ? "household" : entity}
        suggestedDonation={isSuggestedDonation}
      />
    </Wrapper>
  );
};

CostInfoBadge.propTypes = {
  signupItem: object.isRequired,
};

export default CostInfoBadge;
